var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "rule" }, [
    _vm.isApp != 1
      ? _c("div", { staticClass: "content-header" }, [
          _c("i", {
            staticClass: "iconfont icon-left",
            class: { mirrorRotateLevel: _vm.isDirection },
            on: {
              click: function($event) {
                return _vm.$router.go(-1)
              }
            }
          }),
          _vm._v(" "),
          _c("span", { staticClass: "bold" }, [
            _vm._v(_vm._s(_vm.$t("300292")))
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", {
      staticClass: "content-main",
      domProps: { innerHTML: _vm._s(_vm.rule) }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2dea00f9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2dea00f9","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/purchase/rule.vue
// module id = UoJS
// module chunks = 0